import Css from "./style.module.scss";

import { CommentsBlock } from "lib/common";
import { getArchiveData } from "selectors/archive";
import { useSelector } from "react-redux";
import CommentTargetTypes from "const/CommentTargetTypes";
import React, { useMemo } from "react";

const EditVaultFileWindowCommentsBlock = ({ fileId }) => {
  const filesData = useSelector(getArchiveData);

  const fileData = useMemo(() => filesData.find(({ id }) => id === fileId) || {}, [fileId, filesData]);

  return (
    <CommentsBlock
      comments={fileData.comments}
      type={CommentTargetTypes.ARCHIVE}
      id={fileId}
      className={Css.editVaultFileWindowCommentsBlock} />
  );
};

export default React.memo(EditVaultFileWindowCommentsBlock);
